interface CustomResponse<T> {
    data: T | null, 
    message?: string | null, 
}

export default async function Get<T = void>(url: string): Promise<CustomResponse<T>> {
    const response = await fetch(url, {
        method: "GET", 
        headers: {
            "Content-Type": "application/json"
        },
    })

    const contentType = response.headers.get("content-type");

    let data: any = null; 

    if(contentType?.includes("application/json")) {
        try {
            data = await response.json()
        } catch {}
    }

    if (!response.ok) {
        return {
            message: response.statusText, 
            data: null, 
        }
    }

    return {
        data: data, 
        message: "", 
    }
}

export async function Post<T = void>(url: string, params: {}): Promise<CustomResponse<T>> {
    const response = await fetch(url, {
        method: "POST", 
        headers: {"Content-Type": "application/json"}, 
        body: JSON.stringify(params), 
    })

    const contentType = response.headers.get("content-type");

    let data: any = null; 

    if(contentType?.includes("application/json")) {
        try {
            data = await response.json()
        } catch {}
    }

    if (!response.ok) {
        return {
            message: response.statusText, 
            data: null, 
        }
    }

    return {
        data: data, 
        message: "", 
    }
}

